import React from "react";

import { SupChip } from "@repo/core-ui";

interface TxChainProps {
  chainLogo: string;
  chainName: string;
  explorerUrl?: string;
}

export function SupTxChain({ chainLogo, chainName, explorerUrl }: TxChainProps) {
  return explorerUrl ? (
    <a href={explorerUrl} target="_blank" rel="noreferrer">
      <SupChip icon={chainLogo} label={chainName} type="square" border borderStyle="dashed" />
    </a>
  ) : (
    <SupChip icon={chainLogo} label={chainName} type="square" border borderStyle="dashed" />
  );
}
